import React, { Component } from 'react';

class Work extends Component {
  render() {

    if(this.props.data){
      var work = this.props.data.work.map(function(work){
        return <div key={work.company+work.years}>
          <div className="row">
            <div className="two columns max-30 header-col">
              <img src={"images/work/"+work.image} alt={work.company} />
            </div>
            <div className="ten columns main-col">
              <h3>{work.company}</h3>
              <p className="info">{work.title}<br/>
              <em className="date">{work.years}</em></p>
              <p>{work.description}</p>
            </div>
          </div>
        </div>
      })
    }

    return (
      <section id="work">
      <div className="row work">

         <div className="three columns header-col">
            <h1><span>Work</span></h1>
         </div>

         <div className="nine columns main-col">
          {work}
        </div>
    </div>
   </section>
    );
  }
}

export default Work;



// WEBPACK FOOTER //
// ./src/Components/Work.js